import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const ZHPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default ZHPVMonitorPage;
